import styled from "styled-components";
import { ThemeType } from "../../types/Theme";

const NotificacoesContainer = styled.div<{ theme: ThemeType }>`
  padding: 4rem 6rem;
  width: 90vw;
  max-width: 70rem;
  .loading{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  @media(max-width: 768px){
    padding: 2rem 3rem;
  }
  .titulo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span{
      color: ${(props) => props.theme.colors.secondary};
    }
    .toggle-notificacoes{
      font-weight: normal;
      text-align: right;
      display: flex;
      gap: 1rem;
      align-items: center;
      justify-content: center;
      color: ${(props) => props.theme.colors.tertiary};
    }
    &.center{
      justify-content: center;
      color: ${(props) => props.theme.colors.secondary};
      margin-bottom: 4rem;
    }
    font-weight: bold;
  }
  .notificacoes{
    width: 100%;
    padding: 0 1rem;
    max-height: 70vh;
    .sem-notificacoes{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 20rem;
    }
    .data{
      width: 100%;
      display: flex;
      font-weight: bold;
      margin: 1.5rem 0;
    }
    .textos{
      text-align: left;
      width: 100%;
      .texto{
        margin: 2rem 0;
        width: 100%;
        .notificacao-container{
          display: flex;
          width: 100%;
          .conteudo-wrapper{
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-top: -2px;
            margin-left: 2rem;
            .notificacao-titulo{
              color: ${(props) => props.theme.colors.tertiary};
              font-weight: bold;
            }
            .notificacao-texto{
              text-align: left;
            }
          }
        }
      }
    }
    
  }
  .salvar{
    display: flex;
    justify-content: center;
    margin-top: 4rem;
  }
  .toggle{
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
    label{
      margin-right: 3rem;
    }
    
  }
  .texto {
    color: ${(props) => props.theme.colors.tertiary};
  }
  .botoes {
    padding: 3rem 0 5rem 0;
    margin-bottom: 5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    width: 100%;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      width: 80%;
      height: 1px;
      background-color: ${(props) => props.theme.colors.elements};
      top: 100%;
    }
    > a {
      width: 100%;
      text-decoration: none;
    }
  }
  a {
    width: 100%;
    text-decoration: none;
    color: ${(props) => props.theme.colors.tertiary};
    &:focus {
      outline: none;
    }
  }
  @media (max-width: 768px) {
    padding: 5rem 5rem;
  }
  @media (max-width: 345px) {
    padding: 5rem 3rem;
  }
`;

export { NotificacoesContainer };

